/* global jQuery */
/* global dataLayer */

import getCookie from './getCookie';
const $ = jQuery;

$(document).ready(function() {

    ///////////////////////////////
    // Ecommerce analytics start //
    ///////////////////////////////

    // Impressions
    let impressions = [];
    $('.ga-data').each(function(index) {
        const gaData = $(this).data('ga');
        const postsPerPage = jQuery(this).data('posts-per-page');
        const paged = jQuery(this).data('paged');
        const list = $(this).data('list');

        gaData['position'] = (postsPerPage && paged) ? postsPerPage * paged + (index + 1) : index + 1;

        if (list !== '') {
            gaData['list'] = list;
        } else {
            gaData['list'] = $(this).closest('.related').find('h2:first').text();
        }
        impressions.push(gaData);
    });

    if (impressions.length > 0) {
        dataLayer.push({
            event: 'productImpression',
            ecommerce: {
                impressions: impressions
            }
        });
    }

    // Product click
    $('.products .product').click(function() {
        const gaData = $(this).find('.ga-data').data('ga');
        const postsPerPage = jQuery(this).find('.ga-data').data('posts-per-page');
        const paged = jQuery(this).find('.ga-data').data('paged');
        let list = $(this).find('.ga-data').data('list');

        gaData['position'] = (postsPerPage && paged) ? postsPerPage * paged + ($(this).index() + 1) : $(this).index() + 1;

        if (list == '') {
            list = $(this).closest('.related').find('h2:first').text();
        }

        dataLayer.push({
            event: 'productClick',
            ecommerce: {
                click: {
                    actionField: {
                        list: list
                    },
                    products: [gaData]
                }
            }
        });
    });

    // Add / Remove / Update cart
    $(document.body).on('added_to_cart updated_wc_div', function() {
        updateDatalayerWithCart();
    });

    ///////////////////////////////
    // Ecommerce analytics end ////
    ///////////////////////////////

    // Track course applications
    $(document).on('gform_confirmation_loaded', function() {
        const dataContainer = document.getElementById('courseInfo');

        if (!dataContainer) {
            return;
        }

        const course = $(dataContainer).data('course');
        const cost = $(dataContainer).data('cost');

        dataLayer.push({
            event : 'bookCourse',
            course : course,
            cost : cost
        });
    });
});

function updateDatalayerWithCart(checkout = false) {
    if (!getCookie('oldCart') || !getCookie('newCart')) {
        return;
    }

    const oldCart = JSON.parse(decodeURIComponent(getCookie('oldCart').replace(/\+/g, ' ')));
    const newCart = JSON.parse(decodeURIComponent(getCookie('newCart').replace(/\+/g, ' ')));

    if (checkout) {
        if (Boolean(getCookie('checkoutTrackingDone'))) {
            return;
        }

        dataLayer.push({
            event: 'checkout',
            ecommerce: {
                checkout: {
                    products: newCart
                }
            }
        });

        document.cookie = 'checkoutTrackingDone=1;path=/';

        return;
    }

    let added = [];
    let removed = [];

    if (oldCart.length < newCart.length) {
        added = newCart.filter(x => !oldCart.some(y => x.id === y.id));
    } else if (oldCart.length > newCart.length) {
        removed = oldCart.filter(x => !newCart.some(y => x.id === y.id));
    } else {
        newCart.map(x => {
            const y = oldCart.find(y => y.id === x.id);
            if (x.quantity > y.quantity) {
                x.quantity = x.quantity - y.quantity;
                added.push(x);
            } else if (x.quantity < y.quantity) {
                y.quantity = Math.abs(x.quantity - y.quantity);
                removed.push(y);
            }
        });
    }

    if (added.length > 0) {
        dataLayer.push({
            event: 'addToCart',
            ecommerce: {
                add: {
                    products: added
                }
            }
        });
    }

    if (removed.length > 0) {
        dataLayer.push({
            event: 'removeFromCart',
            ecommerce: {
                remove: {
                    products: removed
                }
            }
        });
    }
}

window.updateDatalayerWithCart = updateDatalayerWithCart;
